import * as _ from 'underscore';
import { Util } from './util';
import { IEditObject } from '../interfaces';
import { SortState, PropertyType } from '../enums';
import { SortOptions, ListPropertyOptions, TemplateOptions } from '../interfaces/options';
import { DefaultListPropertyOptions } from '../const/defaultOptions';
import {
	DefaultListPropertyTemplateMapping,
	DefaultListPropertyEditTemplateMapping
} from '../const';

export class ListProperty implements IEditObject<string> {
	public customCss: string;
	public editTemplate: string;
	public isEditable: boolean;
	public isFilterable: boolean;
	public key: string;
	public label: string;
	public rules: KnockoutValidationRule[];
	public sortKey: string;
	public sortState: KnockoutObservable<SortState>;
	public template: string;
	public type: PropertyType;
	protected isSortable: boolean;
	protected isSortActive: KnockoutComputed<boolean>;
	private enumType: any;
	private options: ListPropertyOptions;
	public get sortSetting(): SortOptions {
		return <SortOptions>{
			key: this.sortKey,
			state: this.sortState()
		};
	}
	constructor(options: ListPropertyOptions) {
		options = $.extend(true, {}, DefaultListPropertyOptions, options || {});
		options.template = options.template || DefaultListPropertyTemplateMapping[options.type];
		this.options = options;
		var isEditable = _.isBoolean(this.options.isEditable)
			? this.options.isEditable
			: _.isObject(this.options.isEditable);

		this.isEditable = isEditable;
		this.template = this.options.template;
		this.editTemplate = this.options.isEditable
			? _.isObject(this.options.isEditable)
				? (<TemplateOptions>this.options.isEditable).template
				: DefaultListPropertyEditTemplateMapping[options.type]
			: this.template;
		this.key = this.options.key;
		this.label = this.options.label || this.key;
		this.sortKey = this.options.sortKey || this.key;
		this.isSortable = this.options.isSortable;
		this.type = this.options.type;
		this.isFilterable = this.options.isFilterable;
		this.customCss = this.options.css;
		this.rules = this.options.rules;
		this.enumType = this.options.enumType;
		this.sortState = ko.observable(options.sortState | SortState.NONE);
		this.isSortActive = ko.pureComputed(() => this.sortState() !== SortState.NONE);
	}
	public nextSortState(): SortOptions {
		this.sortState(Util.getNextEnum<SortState>(this.sortState(), SortState));
		return this.sortSetting;
	}
}
